"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _moment = require("moment");

var _moment2 = _interopRequireDefault(_moment);

var _reduxForm = require("redux-form");

var _payments = require("../../redux/modules/payments");

var _auth = require("../../redux/modules/auth");

var _components = require("components");

var _upgradeToAnnualFormValidation = require("../../utils/upgradeToAnnualFormValidation.js");

var _UpgradeSubscriptionPopupForm = require("./UpgradeSubscriptionPopupForm");

var _UpgradeSubscriptionPopupForm2 = _interopRequireDefault(_UpgradeSubscriptionPopupForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UpgradeSubscriptionPopupContainer = (_dec = (0, _reduxForm.reduxForm)({
  form: "checkout",
  fields: ["acceptTos", "captcha"],
  validate: _upgradeToAnnualFormValidation.validate
}, function (state) {
  return {
    email: state.user.email,
    subscription: state.user.subscription,
    customer: state.customer.customer,
    upgradeParams: state.payments.upgradeParams,
    switchedToAnnualPlan: state.payments.switchedToAnnualPlan,
    shouldUpdateEula: state.auth.eula.updateVersion
  };
}, { getUpgradeParams: _payments.getUpgradeParams, switchToAnnualPlan: _payments.switchToAnnualPlan, acceptEULA: _auth.acceptEULA }), _dec(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(UpgradeSubscriptionPopupContainer, _React$Component);

  function UpgradeSubscriptionPopupContainer(props) {
    (0, _classCallCheck3.default)(this, UpgradeSubscriptionPopupContainer);

    var _this = (0, _possibleConstructorReturn3.default)(this, (UpgradeSubscriptionPopupContainer.__proto__ || (0, _getPrototypeOf2.default)(UpgradeSubscriptionPopupContainer)).call(this, props));

    _this.onUpgradeSubmit = _this.onUpgradeSubmit.bind(_this);
    _this.onStartBrowsingClick = _this.onStartBrowsingClick.bind(_this);
    _this.getPaymentLine = _this.getPaymentLine.bind(_this);

    _this.state = {
      error: null
    };
    return _this;
  }

  (0, _createClass3.default)(UpgradeSubscriptionPopupContainer, [{
    key: "onUpgradeSubmit",
    value: function onUpgradeSubmit() {
      var _this2 = this;

      this.setState({
        error: null
      });

      return this.props.switchToAnnualPlan(this.props.upgradeParams.planPrice.price).then(function () {
        if (_this2.props.shouldUpdateEula) {
          _this2.props.acceptEULA();
        }
      }).catch(function () {
        _this2.setState({
          error: "An error occurred while upgrading your plan. Please try again later."
        });
      });
    }
  }, {
    key: "getPaymentLine",
    value: function getPaymentLine(_ref) {
      var cardLast4 = _ref.cardLast4,
          paypalEmail = _ref.paypalEmail;

      return cardLast4 ? "Credit card ending with " + cardLast4 : "PayPal account: " + paypalEmail;
    }
  }, {
    key: "onStartBrowsingClick",
    value: function onStartBrowsingClick() {
      this.props.closePopup();
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          customer = _props.customer,
          upgradeParams = _props.upgradeParams,
          subscription = _props.subscription,
          submitting = _props.submitting,
          handleSubmit = _props.handleSubmit,
          childReference = _props.childReference;
      var error = this.state.error;


      var billingDetails = {
        name: customer.name || "",
        address: customer.address1 || "",
        postalCode: customer.postalCode || "",
        city: customer.address2 || "",
        country: customer.country || ""
      };

      var currentSubscription = {
        name: subscription.planName,
        isMultiSeat: subscription.multiSeat === true,
        numberOfSeats: subscription.numberOfSeats,
        price: upgradeParams.currentPlanAmount,
        points: upgradeParams.currentPlanPoints
      };

      var newSubscription = {
        name: subscription.planName,
        isMultiSeat: subscription.multiSeat === true,
        numberOfSeats: subscription.numberOfSeats,
        points: upgradeParams.points,
        price: upgradeParams.planPrice && parseInt(upgradeParams.planPrice.priceExcludingTax + upgradeParams.currentPlanAmount * 12 - upgradeParams.planPrice.priceExcludingTax),
        discount: upgradeParams.planPrice && upgradeParams.currentPlanAmount * 12 - upgradeParams.planPrice.priceExcludingTax,
        subTotal: upgradeParams.planPrice && upgradeParams.planPrice.priceExcludingTax,
        taxes: upgradeParams.planPrice && upgradeParams.planPrice.vatAmount,
        total: upgradeParams.planPrice && upgradeParams.planPrice.price
      };

      var license = subscription.license,
          createdAt = subscription.createdAt,
          expiresAt = subscription.expiresAt;

      createdAt = license && createdAt ? (0, _moment2.default)(createdAt).format("MMMM Do, YYYY") : null;
      expiresAt = license && expiresAt ? (0, _moment2.default)(expiresAt).format("MMMM Do, YYYY") : null;

      var cardLast4 = this.props.customer.paymentMethod.last4;
      var paypalEmail = this.props.customer.paymentMethod.email;

      return _react2.default.createElement(_UpgradeSubscriptionPopupForm2.default, {
        icon: "/quixel_2080_logo.png",
        error: error,
        fields: this.props.fields,
        email: this.props.email,
        currentSubscription: currentSubscription,
        newSubscription: newSubscription,
        billingDetails: billingDetails,
        subscriptionCreatedAt: createdAt,
        subscriptionNextChargeAt: expiresAt,
        paymentLine: this.getPaymentLine({ cardLast4: cardLast4, paypalEmail: paypalEmail }),
        showSummary: this.props.switchedToAnnualPlan === true,
        submitting: submitting,
        onSubmit: handleSubmit(this.onUpgradeSubmit),
        onStartBrowsingClick: this.onStartBrowsingClick,
        onChildRef: childReference,
        renderCaptcha: function renderCaptcha(field) {
          return _react2.default.createElement(_components.Captcha, { field: field });
        },
        shouldUpdateEula: this.props.shouldUpdateEula
      });
    }
  }]);
  return UpgradeSubscriptionPopupContainer;
}(_react2.default.Component), _class2.contextTypes = {
  router: _react2.default.PropTypes.object
}, _temp)) || _class);
exports.default = UpgradeSubscriptionPopupContainer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/UpgradeSubscriptionPopup/UpgradeSubscriptionPopup.jsx
// module id = 2820
// module chunks = 0